/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../../utils/localStorage';
import { API_RUBUSMASTERS, API_MASTERCONFIGURATION } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { UpdateMasters, CreateMasters, deleteMasters } from '../../APICalls';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  PlusOutlined
} from '@ant-design/icons';
import {
  Form,
  Input,
  message,
  Drawer,
  Select,
  Tooltip,
  Popconfirm,
  Button
} from 'antd';
import translation from '../../Utils/translation';
const ApiList = {
  CreateAsset: `${API_RUBUSMASTERS.AssetAttributesCREATE}`,
  UpdateAsset: `${API_RUBUSMASTERS.AssetAttributesUPDATE}`,
  DeleteAsset: `${API_RUBUSMASTERS.AssetAttributesDELETE}`
};
const { Option } = Select;

const AssetAttributes = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [visibleTypes, setVisibleTypes] = useState(false);
  const [textValue, setTextValue] = useState('');
  const hForm = useRef(null);
  const [translationCache, setTranslationCache] = useState(props.translationCache);


  useEffect(() => {
    _getList();
    getTypeList();
    getModuleList();
   }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache, translationCache]);


  const _getList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `${API_RUBUSMASTERS.AssetAttributesGet}?SiteId=${siteId}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getTypeList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const getTypes = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.GETDROPDOWN}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        TableName: 'sitemaster."SM_AssetTypes"',
        ColumnName: 'Name',
        ColumnValue: 'Code',
        Conditions: [
          {
            key: 'SiteId',
            value: siteId
          }
        ]
      }
    };
    axios(getTypes)
      .then((response) => {
        setTypeList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });  
  };

  const getModuleList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `/api/rubusMaster/modules/get?Status=Active&SiteId=${siteId}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setModuleList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const _editRecord = (record) => {
    let textValue = JSON.stringify(record.API);
    let formObject = {
      ...record,
      API: textValue
    };
    if (hForm.current) {
      hForm.current.setFieldsValue(formObject);
    }
    setFormObject(formObject);
    setTextValue(textValue);
    setVisibleTypes(true);
  };

  const deleteRecord = async (id) => {
    let deleteResponse = await deleteMasters(ApiList.DeleteAsset, id);
    message.success(deleteResponse && deleteResponse.message);
    _getList();
  };

  const onFinish = async () => {
    if (hForm.current) {
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values,
            API: null
          };
          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(ApiList.UpdateAsset, payload, formObject.Id);
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let createResponse = await CreateMasters(ApiList.CreateAsset, payload);
            console.log(createResponse === undefined,'createResponse');
            if(createResponse === undefined){
              setVisibleTypes(false);
            }else{
            message.success(createResponse && createResponse.message);
            }
          }
          _getList();
          hForm.current.setFieldsValue({
            Code: null,
            Name: null,
            ModuleCode: null,
            Type: null,
            isEditableOnUpdate: null,
            mandatory: null,
            widget: null,
            showOnUpdate: null,
            API: null
          });
          setFormObject({});
          setVisibleTypes(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const OpenDrawer = () => {
    let formObject = {
      Code: null,
      Name: null,
      ModuleCode: null,
      Type: null,
      isEditableOnUpdate: null,
      mandatory: null,
      widget: null,
      showOnUpdate: null,
      API: null
    };
    if (hForm.current) {
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        ModuleCode: null,
        Type: null,
        isEditableOnUpdate: null,
        mandatory: null,
        widget: null,
        showOnUpdate: null,
        API: null
      });
    }
    setFormObject(formObject);
    setVisibleTypes(true);
  };

  const onClose = () => {
    if (hForm.current) {
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        ModuleCode: null,
        Type: null,
        isEditableOnUpdate: null,
        mandatory: null,
        widget: null,
        showOnUpdate: null,
        API: null
      });
    }
    setFormObject({});
    setVisibleTypes(false);
  };

  const handleChange = (e, key) => {
    if (key === 'API') {
      try {
        let values = JSON.parse(e.target.value);
        setFormObject({
          ...formObject,
          API: values
        });
        setTextValue(e.target.value);
      } catch (error) {
        console.error("Failed to parse API value:", error);
        // Optionally, set an error state to display to the user
      }
    }
  };

  const columns = [
    {
      title: translation(translationCache, 'Name'),
      dataIndex: 'Name',
      key: 'Name'
    },
    {
      title: translation(translationCache, 'Module Code'),
      dataIndex: 'ModuleCode',
      key: 'ModuleCode'
    },
    {
      title: translation(translationCache, 'Action'),
      dataIndex: 'Action',
      render: (text, record) => (
        <div style={{ display:'flex', flexDirection:'row', gap:'10px'}}>
          <Button onClick={() => _editRecord(record)} >
            <Tooltip title={translation(translationCache, "Edit")}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, 'Are You Sure That You Want To Delete')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteRecord(record.Id)}
            okText={translation(translationCache, 'yes')}
            cancelText={translation(translationCache, 'No')}
          >
            <Button>
              <span>
                <Tooltip title={translation(translationCache, 'Delete')}>
                  <DeleteOutlined />
                </Tooltip>
              </span>
            </Button>
          </Popconfirm>
        </div>
      )
    }
  ];

  return (
    <div style={{ marginLeft: '17px', minHeight: window.innerHeight - 143 }}>
      <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
        <Button type='primary' onClick={OpenDrawer}>
          <PlusOutlined /> {translation(translationCache, 'Add')}
        </Button>
      </div>
      <StyledTable size="small"
        columns={columns}
        dataSource={list}
        pagination={
          list.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
      />
      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update Attribute')
            : translation(translationCache, 'Add Attribute')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visibleTypes}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 12 }}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          <Form.Item
            label={translation(translationCache, 'Code')}
            name="Code"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code !') }]}
          >
            <Input
              placeholder={translation(translationCache, 'Please enter Code')}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Name')}
            name="Name"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Name !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Name')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'ModuleCode')}
            name="ModuleCode"
            rules={[{ required: true, message: translation(translationCache, 'Please select ModuleCode') }]}
          >
            <Select placeholder={translation(translationCache, 'Please select Type')}>
              {moduleList &&
                Array.isArray(moduleList) &&
                moduleList.map((module, index) => (
                  <Option key={index} value={module.AliasCode}>
                    {module.Name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Type')}
            name="Type"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Type !') }]}
          >
            <Select placeholder={translation(translationCache, 'Please select Type')}>
              {typeList &&
                Array.isArray(typeList) &&
                typeList.map((type, index) => (
                  <Option key={index} value={type.Value}>
                    {type.Key}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'isEditableOnUpdate')}
            name="isEditableOnUpdate"
            rules={[
              { required: true, message: translation(translationCache, 'Please enter isEditableOnUpdate !') }
            ]}
          >
             <Select placeholder={translation(translationCache, 'Select isEditableOnUpdate')}>
             <Select.Option value={'true'}>{translation(translationCache, 'true')}</Select.Option>
              <Select.Option value={'false'}>{translation(translationCache, 'false')}</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'mandatory')}
            name="mandatory"
            rules={[
              { required: true, message: translation(translationCache, 'Please select mandatory!') }
            ]}
          >
            <Select placeholder={translation(translationCache, 'Please select mandatory')}>
              <Select.Option value={true}>{translation(translationCache, 'true')}</Select.Option>
              <Select.Option value={false}>{translation(translationCache, 'false')}</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'widget')}
            name="widget"
            rules={[{ required: true, message: translation(translationCache, 'Please select widget') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter widget')} />
          </Form.Item>
          <Form.Item label={translation(translationCache, 'showOnUpdate')} name="showOnUpdate">
            <Select placeholder={translation(translationCache, 'Please enter showOnUpdate')}>
              <Option value={true}>true</Option>
              <Option value={false}>false</Option>
            </Select>
          </Form.Item>
          <Form.Item label={translation(translationCache, 'API')} name="API">
            <Input.TextArea
              style={{ width: '100%' }}
              rows={3}
              value={textValue}
              placeholder={translation(translationCache, 'Please enter API')}
              onChange={(e) => handleChange(e, 'API')}
            />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(AssetAttributes);
